import { render, staticRenderFns } from "./DialogoEvento.vue?vue&type=template&id=3aacb8ac&scoped=true"
import script from "./DialogoEvento.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogoEvento.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DialogoEvento.vue?vue&type=style&index=0&id=3aacb8ac&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aacb8ac",
  null
  
)

export default component.exports